import axios from "axios";
import { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { API_URL } from "../../../../url/api";
import SessionDetails from "../../SessionDetails";

interface User {
  id: number;
  name: string;
  email: string;
}

interface TimeSlot {
  id: number;
  datetime: string;
}

interface ScheduleTime {
  id: number;
  date: string;
}

interface Appointment {
  id: number;
  user: User;
  schedule_time: ScheduleTime;
  time_slot: TimeSlot;
  is_paid: boolean;
}

export type AppointmentData = {
  id: number;
  therapist: {
    id: number;
    name: string;
    email: string;
    phone: string;
    age: string;
    image: string;
    specialty: string;
    experience: number;
    licensure: string;
    message: string | null;
    is_email_send: boolean;
    created_at: string;
  };
  appointment: Appointment[];
};

const AppointmentTable = ({ doctorID }: { doctorID: string }) => {
  const [openSessionPopup, setOpenSessionPopup] = useState(false);
  const [selectedSession, setSelectedSession] = useState(0);

  const [appointmentData, setAppointmentData] =
    useState<AppointmentData | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<AppointmentData>(
          `${API_URL}v2/doctors/${doctorID}/appointment/`
        );
        setAppointmentData(response.data);
      } catch (error) {
        console.error("Error fetching appointment data:", error);
      }
    };

    fetchData();
  }, []);

  if (!appointmentData) {
    return <div>Loading...</div>;
  }

  const { therapist, appointment } = appointmentData;
  console.log("🚀 ~ AppointmentTable ~ appointment:", appointment);

  return (
    <div className="container mx-auto">
      {openSessionPopup && (
        <div className="fixed w-full inset-0 flex flex-wrap items-center justify-center z-50  bg-black/30 backdrop-blur-sm">
          <div className="bg-white rounded-lg p-8 w-full md:w-2/3 overflow-auto h-full lg:h-auto">
            <div className="flex justify-between items-center">
              <h2 className="text-lg font-semibold text-gray-900">
                Appointment Details
              </h2>
              <IoMdCloseCircle
                onClick={() => setOpenSessionPopup(false)}
                size={24}
                className="cursor-pointer"
              />
            </div>
            {/* Add appointment details content here */}
            <SessionDetails sessionId={selectedSession} isCompleted />
          </div>
        </div>
      )}

      <h3 className="text-xl mb-4 mt-6">Completed appointments</h3>
      <div className="overflow-x-auto">
        <table className="w-full bg-white border border-gray-200 space-x-2 space-y-2 overflow-hidden">
          <thead>
            <tr>
              <th className="py-2 px-4 border-b text-left text-nowrap">
                Patient Name
              </th>
              <th className="py-2 px-4 border-b  text-left text-nowrap">
                Date
              </th>
              <th className="py-2 px-4 border-b  text-left text-nowrap">
                Payment Status
              </th>
              <th className="py-2 px-4 border-b  text-left text-nowrap">
                Status
              </th>
              <th className="py-2 px-4 border-b  text-left text-nowrap">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {appointment.map((appt) => (
              <tr key={appt.id}>
                <td className="py-2 px-4 border-b">{appt.user.name}</td>
                <td className="py-2 px-4 border-b">
                  {appt.time_slot.datetime}
                </td>
                <td className="py-2 px-4 border-b">
                  <span
                    className={`inline-block px-2 py-1 text-sm font-semibold rounded-full ${
                      appt.is_paid
                        ? "bg-green-500 text-white"
                        : "bg-red-500 text-white"
                    }`}
                  >
                    {appt.is_paid ? "Paid" : "Unpaid"}
                  </span>
                </td>
                <td className="py-2 px-4 border-b">Scheduled</td>
                <td className="py-2 px-4 border-b">
                  <button
                    type="button"
                    onClick={() => {
                      // window.location.href = `/doctors/${doctorID}/appointment/${appt.id}`;
                      setSelectedSession(appt.id);
                      setOpenSessionPopup(true);
                    }}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AppointmentTable;
